import BulkCreditPurchaseInvoiceFlow from '@Components/PurchaseInvoiceCreation/BulkCreditPurchaseInvoice/BulkCreditPurchaseInvoiceFlow';
import React from 'react';

const CreateBulkCreditPurchaseInvoice = () => {
  return (
    <div>
      <BulkCreditPurchaseInvoiceFlow />
    </div>
  );
};

export default CreateBulkCreditPurchaseInvoice;
